import React from "react";
import "./Game_play_card.css";

function Game_play_card({ imgSrc, onClick }) {
  return (
    <>
      <section className="Game_play_card" onClick={onClick}>
        <div className="img_holder">
          <img src={imgSrc} alt="game card" className="game_cards_img" />
        </div>
      </section>
    </>
  );
}

export default Game_play_card;
